import classNames from "classnames";
import styles from "../daily.module.css";
import { ReactComponent as ArrowButton } from "../svg/arrow.svg";

export interface ArrowButtonProps {
  isEnabled: boolean;
  onArrowClick(): void;
}

export function RightArrowButton(props: ArrowButtonProps) {
  const availableStyleName = "available";
  const { isEnabled } = props;

  return (
    <ArrowButton
      className={classNames(styles["arrow-right"], {
        [styles[availableStyleName]]: isEnabled,
      })}
      onClick={() => {
        if (isEnabled) props.onArrowClick();
      }}
    />
  );
}

export function LeftArrowButton(props: ArrowButtonProps) {
  const availableStyleName = "available";
  const { isEnabled } = props;

  return (
    <ArrowButton
      className={classNames(styles["arrow-left"], {
        [styles[availableStyleName]]: isEnabled,
      })}
      onClick={() => {
        if (isEnabled) props.onArrowClick();
      }}
    />
  );
}
